import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { withSnackbar, ProviderContext } from 'notistack';
import {
  Box,
  Button,
  CardContent,
  Card
} from '@material-ui/core';
import { ScaleLoader } from 'react-spinners';
import { RouteComponentProps } from 'react-router';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import NumberFormat from 'react-number-format';
import { Organization } from '../../interfaces/Organization';
import { ApplicationState, AppState } from '../../store';
import { ITranslatorService } from '../../services/Interfaces/ITranslatorService';
import { IOrganizationService } from '../../services/Interfaces/IOrganizationService';
import { AppContext, ApplicationContext } from '../../context/Contexts';

interface IExchangeRateCoefficientState {
  organization: Organization;
  isLoading: boolean;
}

type IExchangeRateCoefficientProps = { appState: AppState } & ProviderContext &
  RouteComponentProps<{ id: string; workflowId: string }>;

class ExchangeRateCoefficient extends React.PureComponent<
  IExchangeRateCoefficientProps,
  IExchangeRateCoefficientState
> {
  private translatorService!: ITranslatorService;
  private organizationService!: IOrganizationService;
  static contextType = ApplicationContext;

  state = {
    organization: {
      id: 0,
      name: '',
      exchangeRateCoefficient: 0,
      dateCreation: null,
      createdBy: null,
      dateModification: null,
      modifiedBy: null
    } as any as Organization,
    isLoading: false,
    selectedFilter: 0
  } as IExchangeRateCoefficientState;

  public componentDidMount() {
    this.setState(
      {
        isLoading: true
      },
      async () => {
        await this.loadData();
      }
    );
  }

  loadData = async () => {
    const [organization] = await Promise.all([
      this.organizationService.GetOrganization(this.props.appState.appUser?.organizationId || 0),
    ]);

    this.setState({
      organization: organization,
      isLoading: false
    });
  };


  public save = async () => {
    try {
      await this.organizationService.UpdateOrganization(this.state.organization);

      await this.loadData();

      this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
        variant: 'success'
      });
    } catch (error) {
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
    }
  };
  
  NumberFormatCustomCurrencyRate = (props: any) => {
    const { inputRef, onChange, ...other } = props;

    return (
      <NumberFormat
        {...other}
        getInputRef={inputRef}
        onValueChange={(values: any) => {
          onChange({
            target: {
              value: values.value
            },
            currentTarget: {
              value: values.value
            }
          });
        }}
        allowNegative={false}
        thousandSeparator={false}
        decimalScale={4}
      />
    );
  };
  
  public renderAddForm() {
    return (
      <ValidatorForm onSubmit={this.save} instantValidate={true}>
        <Box mb={2}>
          <TextValidator
            fullWidth
            name="name"
            id="name"
            value={this.state.organization.exchangeRateCoefficient || ''}
            onChange={(e: any) => {
              this.setState({
                organization: {
                  ...this.state.organization,
                  exchangeRateCoefficient: parseFloat(e.target.value)
                }
              });
            }}
            label={this.translatorService.Tranlate('EXCHANGE_RATE_COEFFICIENT_LABEL', 'Coeficient Curs Valutar')}
            validators={['required', 'minNumber:1']}
            errorMessages={[
              this.translatorService.Tranlate('VALIDATORS_REQUIRED', 'Campul este obligatoriu'),
              this.translatorService.Tranlate('MIN_EXCHANGE_RATE_COEFFICIENT_LABEL', 'Valoarea minima este 1')
            ]}
            InputProps={{
              inputComponent: this.NumberFormatCustomCurrencyRate,
              style: { fontWeight: 500 }
            }}
          />
        </Box>
      <div className="text-center">
        <Button className="m-2" variant="contained" color="secondary" type="submit">
          {this.translatorService.Tranlate('EDIT_ORGANIZATION_SAVE_BTN', 'Salveaza')}
        </Button>
      </div>
    </ValidatorForm>

    );
  }

  public render() {
    this.translatorService = (this.context as AppContext).translatorService;
    this.organizationService = (this.context as AppContext).organizationService;
    
    return (
      <Fragment>
        <Card>
          <CardContent>
            <Box mt={1} pt={1}>
              <div className="d-flex flex-row text-center flex-wrap justify-content-center">
                <ScaleLoader color={'var(--primary)'} loading={this.state.isLoading} />
              </div>
              {!this.state.isLoading ? this.renderAddForm() : null}
            </Box>
          </CardContent>
        </Card>
      </Fragment>
    );
  }
}

export default connect(
  (state: ApplicationState) => ({
    appState: state.app
  }),
  null
)(withSnackbar(ExchangeRateCoefficient as any));
